import { IntlShape } from 'react-intl';
import { platformMeta } from '../platformMeta';
import { SerializedSocialChannel } from '../types';

/** The weekday name for 0 = Sunday, taken from a week we know the shape of. */
function weekdayName(intl: IntlShape, dayOfWeek: number): string {
  // 2026-08-23 was a Sunday, so the offset lands on the right weekday.
  return intl.formatDate(new Date(Date.UTC(2026, 7, 23 + dayOfWeek)), { weekday: 'short', timeZone: 'UTC' });
}

/**
 * The hour this channel posts at, read local.
 *
 * A learned slot wins when the account has one. Nothing learns one yet, so in
 * practice this is the platform's usual hour — a default we state plainly
 * rather than a measurement of this artist's audience.
 */
export function channelBestSlot(intl: IntlShape, channel: SerializedSocialChannel): string {
  const at = new Date();

  if (channel.bestTimeUtc !== null && channel.bestTimeUtc !== '') {
    const [hours, minutes] = channel.bestTimeUtc.split(':').map((part) => Number(part));
    at.setUTCHours(
      hours === undefined || Number.isNaN(hours) ? 12 : hours,
      minutes === undefined || Number.isNaN(minutes) ? 0 : minutes,
      0,
      0
    );
  } else {
    at.setHours(platformMeta[channel.platform].defaultHour, 0, 0, 0);
  }

  const time = intl.formatTime(at, { hour: '2-digit', minute: '2-digit', hour12: false });
  if (channel.bestDayOfWeek === null) {
    return time;
  }
  return `${weekdayName(intl, channel.bestDayOfWeek)} ${time}`;
}
